module.exports = __webpack_public_path__ + "img/camera-flip.3d16133a.svg";